export default __webpack_public_path__ + "static/forms_compare_comp1_inactive-2-41e360529bf8517aa1a6c0019f837ad2.png";